import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { TopEmployees } from '../../../../server-types';
import { getFullName } from '../../../../utils';
import { ColoredCard } from '../style';
import { CardContent, Typography } from '../../../../ui-kit';
import { useUser } from '../../../../utils/hooks/auth';

const TopEmployeeCard: React.FC<TopEmployees> = ({ firstName, lastName, totalPriceSold, billCount }) => {
    const { priceService } = usePriceService();
    const { t } = useTranslation();
    const { user: { defaultCurrency: { currencyCode } } } = useUser();
    const employeeFullName = getFullName({ firstName, lastName });

    return (
        <ColoredCard fullHeight>
            <CardContent padding={2}>
                <Tooltip title={employeeFullName} aria-label={employeeFullName} placement='top'>
                    <div>
                        <Typography gutterBottom variant='h5' noWrap>{employeeFullName}</Typography>
                    </div>
                </Tooltip>

                <Typography variant='caption' color='textSecondary'>{t('Bills served')}</Typography>
                <Typography variant='body2' gutterBottom>{billCount}</Typography>

                <Typography variant='caption' color='textSecondary'>{t('Gross revenue')}</Typography>
                <Typography variant='body2' gutterBottom>{priceService.toLocaleString(totalPriceSold, currencyCode)}</Typography>
            </CardContent>
        </ColoredCard>
    );
};
export default TopEmployeeCard;
